export default [
    {   
        id: 0,
        title: 'Zuka Event Ticketing',
        link: 'https://zuka.ke',
        image:'zuka.webp',
        category: '.web',
    },

    {   
        id: 1,
        title: 'Body Detector',
        link: 'https://github.com/thekhaleed/Body-Detector-Using-Python',
        image:'ml.webp',
        category: '.ai',
    },
    {   
        id: 2,
        title: 'Bravado FoodHub POS',
        link: 'https://github.com/thekhaleed/bravadoPOS/',
        image:'bravado.webp',
        category: '.web',
    },
    {   
        id: 5,
        title: 'Amba Global LTD',
        link: 'https://ambaglobalfreight.com',
        image:'ambaglobal.webp',
        category: '.web',
    },
    {   
        id: 3,
        title: 'IP Tracker',
        link: 'https://ipatrackerr.netlify.app',
        image:'iptracker.webp',
        category: '.web',
    },
    {   
        id: 4,
        title: 'Utunzi NGO Website',
        link: 'https://utunziafrica.org',
        image:'utunzi.webp',
        category: '.web',
    },
    {   
        id: 6,
        title: 'Freelansa Platform',
        link: 'https://github.com/thekhaleed/Frilansa',
        image:'frilansa.webp',
        category: '.web',
    },
    {   
        id: 7,
        title: 'Iris Project',
        link: 'https://github.com/thekhaleed/Flower-Project',
        image:'auris.webp',
        category: '.ai',
    },
    {   
        id: 5,
        title: 'Vegan Hub NGO Website',
        link: 'https://veganhubafrica.com',
        image:'veganhubafrica.webp',
        category: '.web',
    },

]
